import React, {useEffect, useState} from "react";
import Modal from "../../../components/Modal/Modal";
import {GenerateForm} from "../../../components/cardViewComponents/GenerateForm";
import {validationData} from "../../../components/UI/formValid";
import {validationConfig} from "../../../components/cardViewComponents/validationConfig";
import Notif from "../../../components/Notif";
import {getOpportunityPrepareService} from "../../../services/opportunity/opportunityService";
import myaxios from "../../../components/Axios";

const fieldsConfig = {
    name: {
        label: 'Название',
        type: 'text',
        className: 'w100',
        validation: { required: true, maxLength: 255 }, zone: 1
    },
    status_id: {
        label: 'Статус',
        type: 'select',
        options: [],
        className: 'w100',
        options_from: 'statuses',
        prepare: 'statuses', val: 'id', lab: 'value',
        validation: { required: true, maxLength: 255 }, zone: 1
    },
    stock_id: {
        label: 'Склад',
        type: 'entity',
        link: "/ajax/stock?filter[name][like]=",
        result: 'name',
        entity_from: 'stock',
        entityName: 'name',
        className: 'w100',
        validation: { required: true }, zone: 1
    },
    account_id: {
        label: 'Контрагент',
        type: 'entity',
        link: "/ajax/account?filter[name][like]=",
        result: 'name',
        entity_from: 'account',
        entityName: 'name',
        className: 'w100',
        zone: 1
    },
    provider_id: {
        label: 'Поставщик',
        type: 'entity',
        link: "/ajax/account?filter[name][like]=",
        result: 'name',
        entity_from: 'provider',
        entityName: 'name',
        className: 'w100',
        zone: 1
    },
    owner_id: {
        label: 'Ответственный',
        type: 'entity',
        link: "/ajax/settings/user?filter[name][like]=",
        result: 'name',
        entity_from: 'owner',
        entityName: 'name',
        className: 'w100',
        zone: 1
    },
}

export const PurchaseModal = ({ isOpen, close, history }) => {
    const [loading, setLoading] = useState(true)
    const [errors, setErrors] = useState({})
    const [disabled, setDisabled] = useState({})
    const [values, setValues] = useState({
        name: '',
        owner_id: null,
        owner: null,
        status_id: '',
        stock_id: null,
        stock: null,
        account_id: null,
        account: null,
        provider_id: null,
        provider: null,
        tch: true
    })

    const getPrepare = async () => {
        const { status, data } = await myaxios.get(`/ajax/stock/purchase/prepare`)
        if((status === 200 || status === 201) && data) {
            setValues({
                ...values,
                status_id: data.statuses[0].id,
                statuses: data.statuses,
                name: 'Закупка №' + data.nextId
            })
        }
        setLoading(false)
    }

    const saveItem = async () => {
        const errorsData = validationData(values, validationConfig(fieldsConfig));
        setErrors(errorsData)
        if(Object.keys(errorsData).length > 0) {
            Notif('required-fields')
            return false;
        }

        setLoading(true)
        const { name, owner_id, stock_id, status_id, account_id, provider_id } = values
        const { status, data } = await myaxios.post(`/ajax/stock/purchase`, { name, owner_id, stock_id, status_id, account_id, provider_id })
        if((status === 200 || status === 201) && data.id) {
            history.push(`/stock/purchase/${data.id}`);
            Notif('save')
        }
        setLoading(false)
    }

    useEffect(() => {
        getPrepare().then()
    }, [])

    const changeFields = (key, value, item) => {
        let obj = {}
        if(item) {
            if(item === 'clear') obj[fieldsConfig[key].entity_from] = null
            else obj[fieldsConfig[key].entity_from] = item
        }

        setValues({ ...values, ...obj, [key]: item ? item.id : value, tch: false })
    }

    return (
        <Modal isOpen={isOpen} save={saveItem} close={close} loading={loading} showLeaveModal tch={values.tch} title={'Создать лид'}>
            <GenerateForm
                config={fieldsConfig}
                { ...{ values, errors, disabled } }
                onChange={changeFields}
                onSaveData={saveItem}
            />
        </Modal>
    )
}